/**
 * Single source of truth for "is there an authenticated session right now".
 *
 * A session exists only when BOTH the auth token and the login mode are in
 * localStorage — the same pair `AuthorizeUser` (route guard) checks. Use this to
 * gate auth-required ("x-auth-token") API calls that fire automatically on mount
 * from PUBLIC pages, so logged-out visitors don't spam the backend with calls
 * that can only 401 ("Please log in to continue").
 *
 * For a component that should (re)fire those calls the moment the user logs in
 * WITHOUT a page reload, pair this guard with the reactive login signal:
 *   const accessToken = useSelector((s) => s.login?.accessToken);
 *   useEffect(() => { if (!isLoggedIn()) return; fetchMyThing(); }, [accessToken]);
 * `accessToken` is set in the OTP-verify thunk right AFTER the token is written
 * to localStorage, so by the time the effect re-runs `isLoggedIn()` is already
 * true.
 *
 * @returns {boolean}
 */
export const isLoggedIn = () =>
  Boolean(localStorage.getItem("token") && localStorage.getItem("loginMode"));

export default isLoggedIn;
